import Footer from './Footer';

export default ({ marginTop, marginBottom, padding }) => (
  <>
    <Footer marginTop={marginTop} marginBottom={marginBottom} padding={padding}>
      <p>
        THESE ARE ONLY SOME OF THE THINGS THAT ARE NOT COVERED BY OUR POLICY.{' '}
        <a
          href="https://www.coveinsurance.co.nz/car-insurance/"
          target="_blank"
          rel="noopener noreferrer"
        >
          CLICK HERE
        </a>{' '}
        TO LEARN MORE ABOUT CAR INSURANCE.
      </p>
    </Footer>
  </>
);
